import React from 'react';
import { useResume } from '../context/ResumeContext';

export default function ContactSection() {
  const { activeResume, updateField, validationResults } = useResume();
  const contactVal = validationResults['contact'] || {};

  const handleInputChange = (field, e) => {
    updateField(field, e.target.value);
  };

  const getFieldError = (field) => {
    if (!contactVal.errors) return null;
    return contactVal.errors.find(err => err.toLowerCase().includes(field.toLowerCase()));
  };

  const getFieldWarning = (field) => {
    if (!contactVal.warnings) return null;
    return contactVal.warnings.find(warn => warn.toLowerCase().includes(field.toLowerCase()));
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    background: 'var(--surface-1)',
    border: '1px solid var(--card-border)',
    borderRadius: '8px',
    color: 'var(--text-primary)',
    fontSize: '13px',
    outline: 'none',
    transition: 'border-color 0.15s ease',
    marginTop: '4px',
  };

  const labelStyle = {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
  };

  const fieldContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '8px 0' }}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div style={fieldContainerStyle}>
          <label style={labelStyle}>Full Name</label>
          <input
            type="text"
            value={activeResume?.name || ''}
            onChange={(e) => handleInputChange('name', e)}
            placeholder="John Doe"
            style={{
              ...inputStyle,
              borderColor: getFieldError('name') ? 'var(--status-danger)' : 'var(--card-border)'
            }}
          />
          {getFieldError('name') && (
            <span style={{ fontSize: '10px', color: 'var(--status-danger)', marginTop: '2px' }}>{getFieldError('name')}</span>
          )}
        </div>
        <div style={fieldContainerStyle}>
          <label style={labelStyle}>Job Title / Role</label>
          <input
            type="text"
            value={activeResume?.role || ''}
            onChange={(e) => handleInputChange('role', e)}
            placeholder="Senior Software Engineer"
            style={{
              ...inputStyle,
              borderColor: getFieldWarning('role') ? 'var(--status-warning)' : 'var(--card-border)'
            }}
          />
          {getFieldWarning('role') && (
            <span style={{ fontSize: '10px', color: 'var(--status-warning)', marginTop: '2px' }}>{getFieldWarning('role')}</span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div style={fieldContainerStyle}>
          <label style={labelStyle}>Email Address</label>
          <input
            type="email"
            value={activeResume?.email || ''}
            onChange={(e) => handleInputChange('email', e)}
            placeholder="john.doe@email.com"
            style={{
              ...inputStyle,
              borderColor: getFieldError('email') ? 'var(--status-danger)' : (getFieldWarning('email') ? 'var(--status-warning)' : 'var(--card-border)')
            }}
          />
          {getFieldError('email') && (
            <span style={{ fontSize: '10px', color: 'var(--status-danger)', marginTop: '2px' }}>{getFieldError('email')}</span>
          )}
          {getFieldWarning('email') && !getFieldError('email') && (
            <span style={{ fontSize: '10px', color: 'var(--status-warning)', marginTop: '2px' }}>{getFieldWarning('email')}</span>
          )}
        </div>
        <div style={fieldContainerStyle}>
          <label style={labelStyle}>Phone Number</label>
          <input
            type="text"
            value={activeResume?.phone || ''}
            onChange={(e) => handleInputChange('phone', e)}
            placeholder="+1 555 123 4567"
            style={{
              ...inputStyle,
              borderColor: getFieldError('phone') ? 'var(--status-danger)' : 'var(--card-border)'
            }}
          />
          {getFieldError('phone') && (
            <span style={{ fontSize: '10px', color: 'var(--status-danger)', marginTop: '2px' }}>{getFieldError('phone')}</span>
          )}
        </div>
      </div>

      <div style={fieldContainerStyle}>
        <label style={labelStyle}>Location (City, Country)</label>
        <input
          type="text"
          value={activeResume?.city || ''}
          onChange={(e) => handleInputChange('city', e)}
          placeholder="San Francisco, CA"
          style={{
            ...inputStyle,
            borderColor: getFieldWarning('city') ? 'var(--status-warning)' : 'var(--card-border)'
          }}
        />
        {getFieldWarning('city') && (
          <span style={{ fontSize: '10px', color: 'var(--status-warning)', marginTop: '2px' }}>{getFieldWarning('city')}</span>
        )}
      </div>

      <div style={{ borderTop: '1px solid var(--divider)', paddingTop: '14px', marginTop: '4px' }}>
        <h4 style={{ ...labelStyle, marginBottom: '12px', fontSize: '10px' }}>Social Profiles & Links</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div style={fieldContainerStyle}>
            <label style={{ ...labelStyle, fontSize: '10px' }}>LinkedIn URL</label>
            <input
              type="text"
              value={activeResume?.links?.linkedin || ''}
              onChange={(e) => handleInputChange('links.linkedin', e)}
              placeholder="linkedin.com/in/username"
              style={inputStyle}
            />
          </div>
          <div style={fieldContainerStyle}>
            <label style={{ ...labelStyle, fontSize: '10px' }}>GitHub URL</label>
            <input
              type="text"
              value={activeResume?.links?.github || ''}
              onChange={(e) => handleInputChange('links.github', e)}
              placeholder="github.com/username"
              style={inputStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
